// import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/work-orders',
    name: 'PUT_PRODUCTION_ORDER',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
